<ng-container *ngIf="{ transactionalDataState: transactionalDataState$ | async, sharedDataState: sharedDataState$ | async } as states">

    <div class="production-detail-container">


        <div style="display: flex; gap: 5px">
            <button style="flex-grow: 0" mat-raised-button (click)="goBack()">
                <mat-icon>arrow_back</mat-icon>
            </button>
            <mat-card appearance="outlined" class="header-card">
                <span class="headerInfo"><h3>{{ "app.page.production-detail.nr.label" | translate}}: </h3>{{states.transactionalDataState.selectedProductionOrder?.productionOrderNr}}</span>
                <span class="headerInfo"><h3>{{ "app.page.production-detail.date.label" | translate}}: </h3>{{states.transactionalDataState.selectedProductionOrder?.date | date: 'dd.MM.yyyy'}}</span>
            </mat-card>
        </div>
        <mat-progress-bar color="accent" *ngIf="states.sharedDataState.isLoading || states.transactionalDataState.isLoading" mode="indeterminate"></mat-progress-bar>

        <div class="production-tables">
            <div class="production-table">
                <h3>{{ "app.page.production-detail.production-entry.label" | translate }}</h3>
                <app-production-table
                    [productions]="states.transactionalDataState.selectedProductionOrder?.entry"
                [tableColumns]="layout.productionEntryColumns"></app-production-table>
            </div>
            <mat-divider [vertical]="true"></mat-divider>
            <div class="production-table">
                <h3>{{ "app.page.production-detail.production-exit.label" | translate }}</h3>
                <app-production-table
                    [productions]="states.transactionalDataState.selectedProductionOrder?.exit"
                    [tableColumns]="layout.productionExitColumns"></app-production-table>
            </div>
        </div>

    </div>

</ng-container>
